module.exports = __webpack_public_path__ + "static/media/SMALL-Balance-REPORT.b6abff7a.jpg";